import { render, staticRenderFns } from "./SmallLoader.vue?vue&type=template&id=2d134939&scoped=true&"
import script from "./SmallLoader.vue?vue&type=script&lang=js&"
export * from "./SmallLoader.vue?vue&type=script&lang=js&"
import style0 from "./SmallLoader.vue?vue&type=style&index=0&id=2d134939&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d134939",
  null
  
)

export default component.exports